import styled, { css } from 'styled-components';
import { fsDarkBlue, fsCyan, monokaiBackground, darkModeBackground, colors } from 'global/colors';

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TabList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  column-gap: 5px;
  row-gap: 1px;
`;

export const TabItem = styled.div`
  user-select: none;
  padding: 0.5rem 0.8rem;
  ${({ isDarkMode }) => {
    return css`
      background-color: ${isDarkMode ? '#1f1f1f' : colors.white};
      border: 1px ${isDarkMode ? monokaiBackground : colors.gray3};
    `;
  }}
  position: relative;
  color: #919396 !important;
  /* border: 1px ${colors.gray3}; */
  border-style: solid solid none solid;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  cursor: pointer;
  text-align: center;

  ${({ active, isDarkMode }) =>
    !active &&
    css`
      border-bottom: 1px solid ${isDarkMode ? darkModeBackground : colors.fsLightBlue};
    `}

  ${({ active, isDarkMode }) =>
    active &&
    css`
      cursor: default;
      font-weight: 600;
      color: ${isDarkMode ? fsCyan : fsDarkBlue}!important;
      background-color: ${isDarkMode ? monokaiBackground : colors.white};
      ${({ shouldOverlap }) =>
        // Cover the border from TabList and off-set the height difference
        shouldOverlap &&
        css`
          z-index: 1;
          margin-top: -1px;
          top: 1px;
        `}
    `}
`;

export const TabIcon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  cursor: pointer;
  margin-right: 5px;
  font-size: 1rem;
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      color: ${fsCyan};
    `}
`;

export const HeaderOptions = styled.div`
  margin-right: 5px;
  margin-left: 5px;
`;
